module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_8019.a43e64af.png";